import { BaseHttpController } from '@Core/controller/BaseHttpController';
import { CameraConfigTemplates } from '@EcamModel/model/CameraConfigTemplates';
import { AxiosInstance } from 'axios';
import {
    IApplyCameraConfigTemplateProps,
    ICameraConfigTemplateHttpController,
    IUpsertCameraConfigTemplateProps,
} from '../ICameraConfigTemplateHttpController';

export class CameraConfigTemplateHttpController
    extends BaseHttpController<CameraConfigTemplates>
    implements ICameraConfigTemplateHttpController
{
    constructor(serviceUrl: string, client: AxiosInstance) {
        super(serviceUrl, 'camera-config-template', client);
    }

    async upsertTemplate(props: Partial<IUpsertCameraConfigTemplateProps>): Promise<CameraConfigTemplates> {
        return await this.doPost({ path: 'upsert', body: props }).then((res) => res.data);
    }

    async applyTemplate(props: IApplyCameraConfigTemplateProps): Promise<boolean> {
        return await this.doPost({ path: 'apply', body: props }).then((res) => res.data);
    }
}
